import React, { lazy, Suspense } from 'react';
import { observer } from 'mobx-react';
import { RootContext } from '../../RootProvider';
import LoadingView from '../Interstitial/LoadingView';
const ResourceMapperController = lazy(() => import('./ResourceMapperController'));
const ResourceMapperProvider = () => {
  const root = React.useContext(RootContext);
  return (
    <Suspense fallback={<LoadingView />}>
      <ResourceMapperController viewModel={root.resourceMapper} />
    </Suspense>
  );
};

export default observer(ResourceMapperProvider);
